import { LocalStorageKeys } from '../constants/local-storage-keys'

export class TokenStorage {
    private readonly key = LocalStorageKeys.Jwt

    set(token: string) {
        localStorage.setItem(this.key, token)
    }

    get() {
        const token = localStorage[this.key]

        if (!token) {
            return null
        }

        return token
    }

    remove() {
        localStorage.removeItem(this.key)
    }
}
